import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from 'classnames';
import moment from 'moment';
import formatTime from './../utils/formatTime';
import { VERSION } from './../constants/version';
import { SUBJECT_TYPES, BONUS_TYPE } from './../constants/subjectTypes';
import { tasksFetchIfNeeded, tasksSetViewedIfNeeded } from './../store/tasks/actions';
import { myTaskFetchIfNeeded, myTaskInvalidate } from './../store/myTask/actions';
import { profileFetchIfNeeded, profileInvalidate } from './../store/profile/actions';
import { cost } from 'custom/EssayCost';

import { get } from 'lodash'

import Essay from './../components/Essay';
import Loader from './shared/Loader'

import grid from './../styles/grid.styl';
import baseStyles from 'custom/base.styl';
import styles from 'custom/layout.styl';

// const renderExampleLink = (name, link) => {
//   if (!link) {
//     return null;
//   }
//   return (<li><a target="_blank" href={link} rel="noopener noreferrer">{name}</a></li>);
// };

// const FG_LINKS = {
//   essay_1: 'https://drive.google.com/file/d/16luTkR0K_UfUdPrSXDShJXqeVhw7g1VF/view?usp=sharing',
//   essay_2: 'https://drive.google.com/file/d/1mFPli3TaVWI7I21pjS-NDpnKmH4007Gw/view?usp=sharing',
//   essay_3: 'https://drive.google.com/file/d/1YYlGFxtb0XT9LtVPywEz-O8BP_3XsaMh/view?usp=sharing'
// }

class PageEssayList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      bannerClicked: false,
    }

    this.onClickBanner = this.onClickBanner.bind(this);
  }

  onClickBanner() {
    this.setState({
      bannerClicked: true,
    });
  }

  onRowClick(id) {
    const { match, history, setViewed } = this.props;
    const currentId = match.params.id;

    if (!!currentId && currentId === id.toString()) {
      history.push('/tasks');
      return;
    }

    history.push(`/tasks/${id}`);
    setViewed(id);
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isEssay1List && this.props.isEssay1List) {
      this.setState({
        bannerClicked: false,
      });
    }
    if (prevProps.loadingProfile && !this.props.loadingProfile) {
      const { subjectType, profileVer } = this.props
      let essayType = '';
      if (profileVer === VERSION.v8 || profileVer === VERSION.v9) {
        essayType = `${profileVer}_${subjectType}_esse1`;
        this.props.reloadMyTask(essayType);
      } else {
        this.props.reloadMyTask();
      }
    }

    // if (prevProps.profileStage !== this.props.profileStage) {
    //   this.props.reloadMyTask();
    // }
  }


  renderBody(widthPercent) {
    const width = 1;
    const style = { flexGrow: width, flexShrink: 0, flexBasis: `${widthPercent * width}%` };
    const { tasks, match, isUSA } = this.props;
    const currentId = match.params.id;

    return (
      <div className={baseStyles.table_body}>
        {tasks.map(task => {

          const momentDeadLine = moment();
          const deadline = task.data.deadline;

          momentDeadLine.add(deadline, 'h');
          momentDeadLine.startOf('minute');

          return (
            <div
              key={`essay-list-item-${task.id}`}
              className={classnames(
                grid.space_between,
                grid.row,
                baseStyles.table_row,
                task.viewed ? baseStyles.table_row_read : baseStyles.table_row_unread,
                { [baseStyles.is_active]: task.id.toString() === currentId }
              )}
              onClick={() => this.onRowClick(task.id)}
            >
              <div style={style}>{task.data.subject}</div>
              <div style={style}><p className={baseStyles.capitalize}>{task.data.job_type}</p></div>
              {/* {isUSA &&
                <div style={style} className={baseStyles.centered}>${(task.data.writer_price * 2)}.00</div>
              }
              {!isUSA &&
                <div style={style} className={baseStyles.centered}>${task.data.writer_price}.00</div>
              } */}
              <div style={style}>{task.data.length}</div>
              <div style={style} className={baseStyles.centered}><span>{formatTime(momentDeadLine, 'dt')}</span> / {task.data.deadline}h</div>
            </div>
          )
        })}
      </div>
    )
  }

  renderHeader(widthPercent) {
    const width = 1;
    const style = { flexGrow: width, flexShrink: 0, flexBasis: `${widthPercent * width}%` };

    return (
      <div className={classnames(grid.space_between, grid.row, baseStyles.table_header)}>
        <div style={style}>
          Subject
        </div>

        <div style={style}>
          Type of work
        </div>

        {/* <div style={style} className={baseStyles.centered}>
          You’ll earn
        </div> */}

        <div style={style}>
          Size
          {/* <i className={sortClassnames} /> */}
        </div>

        <div style={style} className={baseStyles.centered}>
          Deadline/ time left
          {/* <i className={sortClassnames} /> */}
        </div>

      </div>
    )
  }

  renderHeaderSubText() {
    const { subjectType } = this.props;
    const sum = BONUS_TYPE[subjectType];

    switch (subjectType) {
      case SUBJECT_TYPES.social:
      case SUBJECT_TYPES.humanities:
      case SUBJECT_TYPES.literature:
        return;

      case SUBJECT_TYPES.math:
      case SUBJECT_TYPES.finance:
        return <p className={classnames(baseStyles.title_extra_small)}>
          Do not forget about a <b>${sum}</b> Welcome Bonus that will be waiting for you in your profile once you nail the last stage as you did on the previous two. Good luck!”
        </p>


      default:
        return <p className={classnames(baseStyles.title_extra_small)}>Do not forget about a <b>${sum}</b> Welcome Bonus that will be waiting for you in your profile once you nail the last stage as you did on the previous two. Good luck!</p>
    }
  }

  renderTable() {
    const widthSum = 6;
    const widthPercent = 100 / widthSum;
    const { match, history, isSecondEssay, isEssay1List, profileVer, isUSA, subjectType } = this.props;
    const { bannerClicked } = this.state;
    const taskId = match.params.id;
    const sum = isUSA ? '$10' : '$5';
    const sumVer2 = isUSA ? `$${cost * 2}` : `$${cost}`;
    const showBanner = profileVer !== VERSION.v0 && isEssay1List && !bannerClicked;

    const showV0 = profileVer === VERSION.v0;
    const showFirst = !showV0 && !isSecondEssay;
    const showSecond = !showV0 && isSecondEssay;
    const isSpecialSubj = (subjectType === 'math' || subjectType === 'finance');

    return (
      <div className={styles.container}>
        <div className={classnames(grid.space_between, grid.row, baseStyles.space_bottom, baseStyles.essay_list_header)}>
          {showV0 &&
            <div className={grid.col_9}>
              <p className={classnames(baseStyles.title_extra_small)}>
                Please select your test essay. You will earn an amount specified in the essay description, if you complete all three test essays on time, following instructions and without plagiarism!
              </p>
            </div>
          }

          {showFirst && profileVer === VERSION.v1 &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>We would like to welcome you in a writing test environment, which is a step away from becoming a freelance writer.</b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>
                You have to complete 2 essays of your own choice and receive $$ for each of them if your training is successful. Ready to roll? Then check out the topics for the 1st essay!
              </p>
            </div>
          }

          {showFirst && (profileVer === VERSION.v2 || profileVer === VERSION.v3) &&
            <div className={grid.col_9}>
              <p className={classnames(baseStyles.title_extra_small)}>
                You are to complete two essays of your own choice and receive a {sumVer2} bonus upon the successful completion of them. Ready to roll? Then check out the topics for the first essay!
              </p>
            </div>
          }

          {showFirst &&
            (profileVer === VERSION.v4 || profileVer === VERSION.v5 ||
              ((profileVer === VERSION.v6 || profileVer === VERSION.v7) && !isSpecialSubj)) &&
            <div className={grid.col_9}>
              <p className={classnames(baseStyles.title_extra_small)}>
                You are to complete two tasks of your own choice. Once both tasks are successfully completed and you are hired, an <b>onboarding bonus</b> will be added right to your financial balance! The bonus amount depends on the subjects you choose to complete test tasks in.
              </p>
            </div>
          }

          {showSecond && profileVer === VERSION.v1 &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>Great job! You have just earned {sum} more on your account!</b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>Just one essay left to finish your training. Please, take it seriously and follow all the instructions provided in order to become our freelance writer and gain all the money you’ve earned here. Ready to roll?</p>
            </div>
          }

          {showSecond && (profileVer === VERSION.v2 || profileVer === VERSION.v3) &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>Awesome! You really did well and we hope our feedback was useful for you. </b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>
                This is the last stage of our testing environment. Now, while completing the second essay, show everything you have learned. Keep in mind that a {sumVer2} bonus is waiting for you if your paper meets the key requirements of academic writing. Good luck!
              </p>
            </div>
          }

          {showSecond &&
            (profileVer === VERSION.v4 || profileVer === VERSION.v5 ||
              ((profileVer === VERSION.v6 || profileVer === VERSION.v7) && !isSpecialSubj)) &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>Awesome! You did great!</b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>
                This is the last stage of our testing environment. It is very important, so please be attentive and show everything you have learned. Reminding you that <b>the onboarding bonus</b> will be added right to your financial balance if you succeed in both test tasks. Good luck! Looking forward to seeing you on the platform!
              </p>
            </div>
          }

          {isSpecialSubj && profileVer !== VERSION.v8 && profileVer !== VERSION.v9 &&
            <div className={grid.col_9}>
              <p className={classnames(baseStyles.title_extra_small)}>
                You are to complete one test task of your choice. In case your tests and the test task meet the requirements you will get access to all available orders and will start earning with us! As a welcome gift, a {isUSA ? '$14' : '$7'} bonus will be added once you are hired! Ready to roll? Good luck!
              </p>
            </div>
          }

          {(profileVer === VERSION.v8) &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>You are at the final stage!</b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>
                Look through the tasks below, choose the one you like, and accept it. Mind that you have 48 hours to complete this task, but the earlier you submit it, the earlier our Recruiting Managers can check it and hire you if all of the requirements are met.
              </p>
            </div>
          }
          {(profileVer === VERSION.v9) &&
            <div className={grid.col_9}>
              <div className={classnames(baseStyles.text_success, baseStyles.text_middle, baseStyles.space_bottom)}>
                <b>You are at the final stage!</b>
              </div>
              <p className={classnames(baseStyles.title_extra_small)}>
                Look through the tasks below, choose the one you like, and accept it. Mind that you have 48 hours to complete this task, but the earlier you submit it, the earlier our Recruiting Managers can check it and hire you if all of the requirements are met.
              </p>
            </div>
          }

          {(profileVer !== VERSION.v9) &&
            <div className={classnames(grid.col_3, baseStyles.right)}>
              <a className={classnames(baseStyles.button_link, baseStyles.transparent)} href="https://drive.google.com/file/d/1gNJt0CS3X5EHDPEt02IhiPxkJ2CKssjI/view" target="_blank" rel="noopener noreferrer"><b>FAQ & Guides</b></a>
            </div>
          }
        </div>

        <div className={baseStyles.table_wrap}>
          <div className={baseStyles.table}>
            {this.renderHeader(widthPercent)}
            {this.renderBody(widthPercent)}
            {!!taskId && <Essay taskId={taskId} history={history} isUSA={isUSA} />}
          </div>
        </div>
        {showBanner &&
          <div className={baseStyles.success_banner}>
            34 essays are waiting for you on our platform! To unlock complete two *paid* sample essays
            <i onClick={this.onClickBanner} className={baseStyles.close} />
          </div>
        }
      </div>
    )
  }

  renderActiveTask() {
    const { myTaskId, isUSA, profileVer } = this.props;
    // const fgLink = profileVer === VERSION.v8 ? FG_LINKS['essay_1'] : FG_LINKS[profileStage]
    const fgLink = 'https://drive.google.com/file/d/1gNJt0CS3X5EHDPEt02IhiPxkJ2CKssjI/view';


    return (
      <div className={styles.container}>
        <div className={classnames(grid.space_between, grid.row, baseStyles.space_bottom, baseStyles.xs_block)}>
          <div className={classnames(grid.col_8, baseStyles.text)}>
            Check the instructions carefully and submit the task before the stated deadline. Good luck!
          </div>
          {(profileVer !== VERSION.v9) &&
            <div className={classnames(grid.col_4, baseStyles.right)}>
              <a className={classnames(baseStyles.button_link, baseStyles.transparent)} href={`${fgLink}`} target="_blank" rel="noopener noreferrer"><b>FAQ & Guides</b></a>
            </div>
          }
        </div>
        <div className={baseStyles.single_page}>
          <Essay standalone taskId={myTaskId} isUSA={isUSA} />
        </div>
      </div>
    );
  }

  render() {
    const { myTaskId, loading } = this.props;
    if (loading) {
      return <Loader absolute />
    }
    if (!myTaskId) {
      return this.renderTable();
    }
    return this.renderActiveTask();
  }
}

const ESSAY_STAGE_TYPE_MAP = {
  essay_1: 'esse1',
  essay_2: 'esse2',
  essay_3: 'esse3',
  essay_4: 'esse4',
  essay_5: 'esse5',
  v8_math_esse1: 'v8_math_esse1',
  v8_finance_essay_1: 'v8_finance_esse1',
  v8_finance_text_essay_1: 'v8_finance_text_esse1',
  v8_engineering_essay_1: 'v8_engineering_esse1',
  v8_social_essay_1: 'v8_social_esse1',
  v8_humanities_essay_1: 'v8_humanities_esse1',
  v8_environmental_essay_1: 'v8_environmental_esse1',
  v8_literature_essay_1: 'v8_literature_esse1',
  v8_it_essay_1: 'v8_it_esse1',
  v8_chemistry_essay_1: 'v8_chemistry_esse1',
  v8_business_essay_1: 'v8_business_esse1',
  v9_math_esse1: 'v9_math_esse1',
  v9_finance_essay_1: 'v9_finance_esse1',
  v9_finance_text_essay_1: 'v9_finance_text_esse1',
  v9_engineering_essay_1: 'v9_engineering_esse1',
  v9_social_essay_1: 'v9_social_esse1',
  v9_humanities_essay_1: 'v9_humanities_esse1',
  v9_environmental_essay_1: 'v9_environmental_esse1',
  v9_literature_essay_1: 'v9_literature_esse1',
  v9_it_essay_1: 'v9_it_esse1',
  v9_chemistry_essay_1: 'v9_chemistry_esse1',
  v9_business_essay_1: 'v9_business_esse1',
};

const mapStateToProps = state => {
  const loadingProfile = !state.profile.data || state.profile.isFetching;
  const loading = loadingProfile || !state.tasks.data || state.tasks.isFetching || !state.myTask.data || state.myTask.isFetching;
  const myTaskId = !loading && state.myTask.data && state.myTask.data.active_task && state.myTask.data.active_task.id;
  const utmType = get(state.profile.data, 'user.profile.utm_type');
  const isUSA = utmType && utmType === 'usa';
  const profileStage = get(state.profile.data, 'user.stage', {});
  const profileVer = get(state.profile.data, 'user.scenario_version', 'v1');
  const isSecondEssay = profileStage === 'essay_2';
  const isEssay1List = profileStage === 'essay_1' && !myTaskId;
  const subjectType = get(state.profile.data, 'user.profile.subject_type');
  const activeTaskEntity = state.myTask.data && state.myTask.data.active_task;
  const completedDetails = activeTaskEntity && activeTaskEntity.task && activeTaskEntity.task.data;

  let essayType = `${profileVer}_${ESSAY_STAGE_TYPE_MAP[profileStage]}`;
  if (profileStage === 'subject_essay_1') {
    essayType = `${profileVer}_${subjectType}_esse1`;
  }

  return {
    myTaskId,
    loadingProfile,
    tasks: get(state.tasks, 'data.tasks', []).filter(t => t.task_type === essayType),
    loading,
    error: state.tasks.error,
    completedDetails,
    profileStage,
    isSecondEssay,
    isEssay1List,
    profileVer,
    subjectType,
    isUSA,
    essayType,
  }
}

const mapDispatchToProps = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
    // dispatch(tasksFetchIfNeeded());
    // dispatch(myTaskInvalidate());
    // dispatch(myTaskFetchIfNeeded());
  },
  reloadMyTask: (task_type) => {
    dispatch(tasksFetchIfNeeded(task_type));
    dispatch(myTaskInvalidate());
    dispatch(myTaskFetchIfNeeded());
    // dispatch(myTaskInvalidate());
    // dispatch(myTaskFetchIfNeeded());
  },
  setViewed: id => dispatch(tasksSetViewedIfNeeded(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageEssayList);



// WEBPACK FOOTER //
// ./src/components/PageEssayList.js